import { Box, Typography, IconButton } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import { useEffect, useRef, useState } from "react";
import { shortsDataYT } from "../../data/shortsData";

export default function ShortsReelSectionYT() {
  const [activeSoundId, setActiveSoundId] = useState(null);
  const scrollRef = useRef(null);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    let scrollAmount = 0;
    const speed = 0.3;

    const scroll = () => {
      scrollAmount += speed;
      container.scrollLeft = scrollAmount;

      if (
        container.scrollLeft + container.clientWidth >=
        container.scrollWidth - 1
      ) {
        scrollAmount = 0;
      }
    };

    const interval = setInterval(scroll, 20);
    return () => clearInterval(interval);
  }, []);

  const toggleSound = (id) => {
    setActiveSoundId((prev) => (prev === id ? null : id));
  };

  return (
    <Box
      sx={{ py: { xs: 4, md: 4 }, background: "#fff", position: "relative" }}
    >
      {/* HEADER */}
      <Box textAlign="center" mb={2}>
        <Typography sx={{ fontSize: { xs: 26, md: 34 }, fontWeight: 600 }}>
          Our Latest{" "}
          <Box component="span" sx={{ color: "var(--color-gold)" }}>
            Shorts
          </Box>
        </Typography>
        <Typography sx={{ mt: 1, color: "var(--color-text-muted)" }}>
          Moments, insights & behind-the-scenes from Vision X Nexus
        </Typography>
      </Box>

      {/* STRIP */}
      <Box
        ref={scrollRef}
        sx={{
          display: "flex",
          gap: 2,
          px: 2,
          overflowX: "auto",
          scrollBehavior: "smooth",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {shortsDataYT.map((item) => (
          <ShortCard
            key={item.id}
            item={item}
            isActive={activeSoundId === item.id}
            onToggle={() => toggleSound(item.id)}
          />
        ))}
      </Box>
      {/* BOTTOM GOLD LINE */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />
    </Box>
  );
}

function ShortCard({ item, isActive, onToggle }) {
  const embedSrc = `https://www.youtube.com/embed/${item.youtubeId}?autoplay=1&mute=${
    isActive ? 0 : 1
  }&controls=0&loop=1&playlist=${item.youtubeId}&playsinline=1&modestbranding=1`;

  return (
    <Box
      onClick={onToggle}
      sx={{
        minWidth: 200,
        height: 360,
        borderRadius: "20px",
        overflow: "hidden",
        position: "relative",
        cursor: "pointer",
      }}
    >
      {/* YOUTUBE IFRAME */}
      <iframe
        src={embedSrc}
        title={item.title}
        allow="autoplay; encrypted-media"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />

      {/* GRADIENT */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, transparent 60%, rgba(0,0,0,0.6))",
        }}
      />

      {/* TITLE */}
      {/* <Typography
        sx={{
          position: "absolute",
          bottom: 14,
          left: 14,
          right: 14,
          color: "#fff",
          fontSize: 13,
          fontWeight: 500,
        }}
      >
        {item.title}
      </Typography> */}

      {/* SOUND ICON */}
      <IconButton
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
          color: "#fff",
          background: "rgba(0,0,0,0.45)",
          backdropFilter: "blur(6px)",
          animation: isActive ? "pulse 1.4s infinite" : "none",
          "@keyframes pulse": {
            "0%": { boxShadow: "0 0 0 0 rgba(247,148,29,0.6)" },
            "70%": { boxShadow: "0 0 0 10px rgba(247,148,29,0)" },
            "100%": { boxShadow: "0 0 0 0 rgba(247,148,29,0)" },
          },
        }}
      >
        {isActive ? <VolumeUpIcon /> : <VolumeOffIcon />}
      </IconButton>
    </Box>
  );
}
